'use client';

import { format, parseISO } from 'date-fns';
import { tz } from '@date-fns/tz';
import type { DeliveryDateRange } from '../../model/siteconfig/siteconfig';

/**
 * Formats the delivery date range from backend into a user-friendly string.
 *
 * @param deliveryDateRange Delivery date range from backend (minDate, maxDate in ISO format)
 * @param timeZone User's timezone (default: browser timezone)
 * @returns Formatted delivery date string (e.g., "Mon, 07 Jul - Wed, 09 Jul")
 */
export const formatDeliveryDateRange = (
  deliveryDateRange: DeliveryDateRange,
  timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string => {
  const minDate = parseISO(deliveryDateRange.minDate);
  const maxDate = parseISO(deliveryDateRange.maxDate);

  const minDateFormatted = format(minDate, 'EEE, dd MMM', { in: tz(timeZone) });
  const maxDateFormatted = format(maxDate, 'EEE, dd MMM', { in: tz(timeZone) });

  return `${minDateFormatted} - ${maxDateFormatted}`;
};

